import { memo } from 'react';
import { Box } from '@chakra-ui/react';

const PropertyTableLoadingState = memo(function PropertyTableLoadingState() {
  return (
    <Box flex={1} display={'flex'} alignItems={'center'} justifyContent={'center'}>
      Loading…
    </Box>
  );
});

export default PropertyTableLoadingState;
